import { Transition } from '@headlessui/react';

/**
 * Returns the response notification based on the action prompt of the user component.
 * 
 * @param {*} props 
 * @returns The response notification based on the action prompt of the user component.
 */
const ResponseNotification = (props) => {
    return (
        <div
            aria-live="assertive"
            className="pointer-events-none fixed flex left-0 right-0 items-start px-4 py-6 sm:p-6 sm:inset-0 sm:absolute"
        >
            <Transition
                className="flex w-full flex-col items-center space-y-4 sm:items-end"
                show={props.show}
                as={props.Fragment}
                enter="transform ease-out duration-300 transition"
                enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className={"pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 " + (props.isApprove ? "bg-green-100" : "bg-red-100")}>
                    <div className="p-4">
                        <div className="flex items-start">
                            <div className="ml-3 w-0 flex-1 pt-0.5">
                                <p className="text-sm font-medium text-gray-900">Project {props.isApprove ? "Approved!" : "Rejected!"}</p>
                                <p className="mt-1 text-sm text-gray-500">Contributor {props.isApprove ? "can now" : "cannot"} upload large files.</p>
                            </div>
                            
                            <div className="ml-4 flex flex-shrink-0">
                                <button
                                    type="button"
                                    className="inline-flex text-gray-400 hover:text-gray-500"
                                    onClick={() => {
                                        props.setShow(false)
                                    }}
                                >
                                    <span className="sr-only">Close</span>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    );
};
 
export default ResponseNotification;